import {EntityApiService, ApiClientService} from '@dofleini/security';

class ServicesApiService extends EntityApiService {

    getOneService = ({serviceId}) => ApiClientService.get(this.getPath(`/${serviceId}`));


    getAssociatedFilters = (params) => ApiClientService.post(this.getPath('/search-from-client'), params);

}

export default new ServicesApiService('/ms-core/api/services');
